import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppServerAPI } from '@sdbn/common';
import { TruckGroup } from '../truck-group.model';
import { MasterDataComponent } from '../../transport-registration/component/master-data/master-data.component';
import { MasterDetailListEntry } from '@sdbn/common';
import { event } from 'd3';

@Component({
  selector: 'app-truck-group-admin',
  templateUrl: './truck-group-admin.component.html',
  styleUrls: ['./truck-group-admin.component.scss']
})
export class TruckGroupAdminComponent implements OnInit {



  truckGroups = new Array<TruckGroup>();

  currentTruckGroup: TruckGroup;

  clonedCurrentTruckGroup: TruckGroup;

  formGroup: FormGroup<{
    name: FormControl;
    priority: FormControl;
  }>

  truckGroupChanged = false;
  truckChanged = false;

  isLoading = true;

  constructor(
    private appServerAPI: AppServerAPI,
  ) {
    this.formGroup = new FormGroup({
      name: new FormControl(null, [Validators.required]),
      priority: new FormControl(null, [Validators.required]),
    });

    this.getTruckGroups();

    this.formGroup.valueChanges.subscribe(value => {
      this.currentTruckGroup.name = value.name;
      this.currentTruckGroup.priority = value.priority;
    })
  }

  ngOnInit() { }

  private reload() {
    this.formGroup.patchValue({
      name: this.currentTruckGroup.name,
      priority: this.currentTruckGroup.priority,
    });

    this.formGroup.markAsPristine();
    this.formGroup.markAsUntouched();
  }

  private getTruckGroups() {
    this.appServerAPI.execute<Array<TruckGroup>>('/client/admin/truckgroup/get', this.currentTruckGroup).subscribe((results) => {
      let resultTruckGroups = new Array<TruckGroup>();
      for (const result of results) {
        const truckGroup = new TruckGroup(result);
        resultTruckGroups.push(truckGroup);
      }
      this.truckGroups = resultTruckGroups;

      if (this.truckGroups.length > 0) {
        this.currentTruckGroup = this.truckGroups[0]
      }


      this.reload()

      this.isLoading = false;

    })
  }

  onSave() {
    this.appServerAPI.execute('/client/admin/truckgroup/save', this.currentTruckGroup).subscribe((result) => {
    })
  }

  onDelete(entry: MasterDetailListEntry) {
    const truckGroup = entry as TruckGroup;

    if (truckGroup.id != null) {
      this.appServerAPI.execute('/client/admin/truckgroup/delete', truckGroup).subscribe((result) => {
      })
    }

    const index = this.truckGroups.indexOf(truckGroup);
    this.truckGroups.splice(index, 1);

    if (this.truckGroups.length > 1) {
      this.currentTruckGroup = this.truckGroups[0]
    }

  }

  changeSelection(truckGroup: MasterDetailListEntry) {
    if (truckGroup != undefined) {
      this.currentTruckGroup = truckGroup as TruckGroup;
      this.reload()
    }
  }

  addEntry(event: MasterDetailListEntry[]) {
    const newTruckGroup = new TruckGroup({})
    this.truckGroups.push(newTruckGroup);
    this.currentTruckGroup = newTruckGroup;
  }

  onTruckChanged(event: boolean) {
    this.truckChanged = event;
  }

  onTruckGroupChanged(event: boolean) {
    this.truckGroupChanged = event;
  }
}
